import { Injectable } from '@angular/core';
import {Observable, ReplaySubject} from "rxjs";
import {CountedAndPaginated} from "../interface/response/counted-and-paginated";
import {Employee, LeaveApplication} from "../interface/employee";
import {HttpClient, HttpErrorResponse} from "@angular/common/http";
import {FilterService} from "./filter.service";
import {first, take} from "rxjs/operators";
import {LicensedAgent} from "../interface/licensed-agent";
import {Document as DocumentInterface} from "../interface/document";
import {ListResponse} from "../interface/response/list-response";
import {Uuid} from "../interface/response/uuid";
import {el} from "@fullcalendar/core/internal-common";

@Injectable({
  providedIn: 'root'
})
export class EmployeeService {
  public readonly employeeListSubject: ReplaySubject<CountedAndPaginated<Employee>>
    = new ReplaySubject<CountedAndPaginated<Employee>>(1);

  constructor(
    private httpClient: HttpClient,
    private filterService: FilterService,
  ) { }

  public loadList(page: number, pageSize: number, filters: object): void
  {
    this.httpClient.get(`/rest/crm/employee?page=${page + 1}&pageSize=${pageSize}&`
      + this.filterService.parseFilters(filters))
      .pipe(
        first()
      )
      .subscribe({
        next: (result: CountedAndPaginated<Employee>) => {
          this.employeeListSubject.next(result);
        }, error: (error: HttpErrorResponse) => {
          this.employeeListSubject.error(error);
        }
      });
  }

  public get(employeeId: string): Observable<Employee> {
    return this.httpClient.get(`/rest/crm/employee/${employeeId}`)
      .pipe(first()) as Observable<Employee>;
  }

  public sendFormAplication(formData: object, uuid?: string): Observable<any> {
    if (uuid) {
      return this.httpClient.put(`/rest/crm/leave-application/${uuid}`, formData)
        .pipe(
          take(1)
        );
    } else {
      return this.httpClient.post('/rest/crm/leave-application', formData)
        .pipe(
          take(1)
        );
    }
  }

  public sendForm(formData: object,  employeeId?: string): Observable<any> {
    return this.httpClient.put(`/rest/crm/employee/${employeeId}`, formData)
      .pipe(
        take(1)
      );
  }

  getLeaveApplication(employeeId: string, filters: object): Observable<ListResponse<LeaveApplication>> {
    return this.httpClient.get(`/rest/crm/employee/${employeeId}/leave-application?` + this.filterService.parseFilters(filters))
      .pipe(first()) as Observable<ListResponse<LeaveApplication>>;
  }
  public downloadReport(filters: object): Observable<Uuid> {
    return this.httpClient.post(`/rest/crm/employee/method/report?` + this.filterService.parseFilters(filters), {})
      .pipe(first()) as Observable<Uuid>;
  }

}
